import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'kt-user-settings',
  templateUrl: './user-settings.component.html',
  styleUrls: ['./user-settings.component.scss']
})
export class UserSettingsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
